export const BANNER_VARIANTS = {
  horizontal: 'horizontal',
  vertical: 'vertical',
  content: 'content',
  inList: 'content_inner',
};

export const VERSIONS = {
  mobile: 'mobile',
  desktop: 'desktop',
};

export const BANNERS = {
  top: {
    id: 'react-bn-slot-top',
    slot: 'bn-slot-top',
  },
  premium: {
    id: 'react-bn-slot-premium',
    slot: 'bn-slot-premium',
    hide: VERSIONS.mobile,
    isSticky: false,
  },
  sticky: {
    id: 'react-bn-slot-sticky-1a',
    slot: 'bn-slot-sticky-1a',
    isSticky: true,
    hide: VERSIONS.mobile,
  },
  skyLeft: {
    id: 'react-bn-slot-sky-left',
    slot: 'bn-slot-sky-left',
    hide: VERSIONS.mobile,
  },
  content1: {
    id: 'react-bn-slot-content',
    slot: 'bn-slot-content',
    hide: VERSIONS.desktop,
  },
  content2: {
    id: 'react-bn-slot-content-2',
    slot: 'bn-slot-content-2',
  },
  catfish: {
    id: 'react-bn-slot-catfish',
    slot: 'bn-slot-catfish',
    hide: VERSIONS.desktop,
  },
  bottom: {
    id: 'react-bn-slot-bottom',
    slot: 'bn-slot-bottom',
  },
  branding: {
    id: 'react-bn-slot-branding',
    slot: 'bn-slot-branding',
    hide: VERSIONS.mobile,
  },
  topAnchor: {
    id: 'react-bn-slot-top-anchor',
    slot: 'bn-slot-top-anchor',
    hide: VERSIONS.desktop,
  },
};
